import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 800px;
  flex: 1;
  padding: 2rem;
  padding-bottom: 0;
  gap: .75rem;
  flex-direction: column;
  background: #f3f4f6;
`;
export const Title = styled.div`
  position: relative;
  width: 100%;
  max-width:700px;
  text-align: center;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1.3rem;
  margin-top: 1.75rem;
  font-weight: bolder;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  > span {
    position: absolute;
    display: flex;
    width: 5rem;
    height: 5rem;
    top: -35px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffff;
    background-color: #1D86FF;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px
  }
  > div {
    margin-left: 5rem;
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.2rem;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  overflow: hidden;
  > div:nth-child(1){
    display: flex;
    gap: .5rem;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    .uFN{
      border-radius: 4px;
      max-width: 450px;
      background: transparent;
      border:solid 1px #e8e8e8;
    };
    .uFS{
      max-width: 100px;
    };
    > button{
      outline: none;
      border: none;
      display: flex;
      width: 10rem;
      gap: 0.5rem;
      padding: 0.5rem;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;
      background-color: #1D86FF;
      color: #ffffff;
      font-size: 14px;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
      &:hover{
        opacity: 0.9;
      }
    }
  };
`;
export const ListHolidays = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-bottom: 3.5rem;
  > div {
    display: flex;
    min-height: 2rem;
    width: 100%;
    background: #ecedef;
    > div  {
      display: flex;
      /* padding-left: 10px; */
      justify-content: left;
      align-items: center;
    }
    > div:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 20%;
        flex: 1;
    }
    > div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 30%;
        flex: 2;
    }
    > div:nth-child(3) {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 50%;
        flex: 3;
    }
  };
  > ul {
    display: flex;
    flex-direction: column;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.2);
    }
  }
`;
export const BoxSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  .box--{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    .line-{
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      justify-content: space-between;
      .date{
        width: 10rem;
        border: 1px solid #1D86FF;
        background-color: transparent;
      }
    }
  }
  .list-{
    width: 20rem;
  }
`;
export const BtnSearch = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: 3rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
    background-color: #1D86FF;
    font-size: 1.5rem;

    .loader{
      display: flex;
      border: 2px solid #ffffff;
      border-radius: 50%;
      border-top: 2px solid #1d83e2;
      width: 2rem;
      height: 2rem;
      animation: spin 1.5s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
`;